import { Popover, OverlayTrigger } from "react-bootstrap";
import { InfoCircle } from 'react-bootstrap-icons';

const popoverPackaging = (
    <Popover id="popover-packaging-help">
      <Popover.Header as="h3">Packaging Details</Popover.Header>
      <Popover.Body>
        <p>
        ${`每 {Packaging} HKD 0.00 ( 1 {Packaging} = {Unit Quantity} {Unit Name} )`}
        </p>
        <p>
        ${`每包 HKD 0.00 (1包 = 5隻)`}  
        </p>
      </Popover.Body>
    </Popover>
  );

const PopoverPackaging = (props) => (
<OverlayTrigger 
    trigger="click" 
    placement={props.placement}
    overlay={popoverPackaging}
    rootClose={true}
>
    <span className="font-weight-bold is-hover"><u><InfoCircle size={16} className="mb-1 mr-1" /> Packaging Details</u></span>
</OverlayTrigger>
);

export default PopoverPackaging;